import {
  fetchRewardProgramState,
  PowerSwitchStatus
} from 'api/blockchain/rewardProgram';
import { useWeb3React } from 'hooks/web3';
import { useQuery } from 'react-query';
import { useConnection } from 'store/connection';
import { RewardProgram } from 'types';
import { Queries } from 'types/enum';

export function useRewardProgramState(rewardProgram?: RewardProgram) {
  const { provider, chainId } = useWeb3React();
  const { tried } = useConnection();
  return useQuery<PowerSwitchStatus, Error>(
    [Queries.REWARD_PROGRAMS, rewardProgram?.address, chainId],
    () => fetchRewardProgramState(rewardProgram!, provider),
    {
      enabled: tried && !!rewardProgram
    }
  );
}
